import React from 'react'
import styled from 'styled-components'

export type SearchWithOtherQueryProps = {
  title: string,
  category_abbreviation: string,
  queryItems: QueryItem[],
}

export type QueryItem = {
  label: string,
  id: number,
}

type QueryListProps = {
  children?: React.ReactNode,
}

export const StyledTitle = styled.h2`
  margin-bottom: 20px;
  font-weight: bold;
  line-height: 1.75;
  font-size: 1rem;

  @media ${props => props.theme.media.sm} {
    font-size: 1.25rem;
  }

  &::before {
    content: "";
    position: relative;
    display: inline-block;
    margin-right: 3px;
  }
`

const StyledQueryList = styled.ul`
  list-style: none;
  margin-left: 0;
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
  gap: 16px 40px;
  margin: 0;
  grid-area: 8px 24px;

  @media ${props => props.theme.media.sm} {
    grid-area: auto;
  }
` as React.FC<QueryListProps>

const StyledQueryItem = styled.a`
  text-decoration: none;
  color: ${props => props.theme.members.colors.appleGreen._90};
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.75;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    color: ${props => props.theme.members.colors.appleGreen._90};
    text-decoration: underline;
    cursor: pointer;
  }

  @media ${props => props.theme.media.sm} {
    font-size: 0.875rem;
  }
`

export const SearchWithOtherQuery: React.FC<SearchWithOtherQueryProps> = (props: SearchWithOtherQueryProps) => {
  return (
    <div data-cy={`job-offers-seo-contents-${props.category_abbreviation}`}>
      <StyledTitle>{props.title}</StyledTitle>
      <StyledQueryList>
        {props.queryItems.map(query => {
          return (
            <li key={query.label}>
              <StyledQueryItem href={`/job_offers/${props.category_abbreviation}/${String(query.id)}`}>{query.label}</StyledQueryItem>
            </li>
          )
        })}
      </StyledQueryList>
    </div>
  )
}
